import { goToUrl } from "apps/visits/core/utils/go-to-url";
import type { AxiosError } from "axios";
import { t } from "i18next";
import type { LoginErrorResponse } from "../../api/group-actions-ordering.types";
import { routes } from "../../config/routes";

export const extractLoginErrorType = (error: AxiosError<LoginErrorResponse> | null | undefined): string => {
  if (!error) return "unknown";
  const body = error.response?.data?.error;
  if (!body) return "unknown";

  if (body.estimated_number_of_patients) return "patients_limit_reached";
  if (body.base?.some((e) => e.error === "code_expired")) return "code_expired";
  if (body.base?.some((e) => e.error === "patient_already_registered")) return "patient_already_registered";
  return "unknown";
};

export const handleLoginApiErrors = (error: AxiosError<LoginErrorResponse> | null): string | undefined => {
  if (!error) return undefined;

  const loginError = error?.response?.data?.error;
  const codeExpiredError = loginError?.base?.filter((errorObj) => errorObj.error === "code_expired");
  const alreadyRegisteredError = loginError?.base?.filter((baseErr) => baseErr.error === "patient_already_registered");

  if (loginError?.estimated_number_of_patients) {
    goToUrl(routes.limitReached.raw());
    return undefined;
  }

  if (codeExpiredError && codeExpiredError.length > 0) return t("GROUP_ACTIONS_ORDERING.ERRORS.CODE_VALIDATION_ERROR");

  if (alreadyRegisteredError && alreadyRegisteredError.length > 0)
    return t("GROUP_ACTIONS_ORDERING.ERRORS.PATIENT_ALREADY_REGISTERED");

  return t("COMMONS.ERRORS.GENERAL_API_ERROR");
};
